import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from '@angular/core';
import { SystemError, SystemStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
    standalone: false,
})
export class OverviewComponent implements OnInit, OnChanges {
    @Input() systemStatusData: SystemStatus;
    @Input() isReceivingData: boolean;
    @Output() onPageSelected: EventEmitter<string> = new EventEmitter<string>();

    systemErrors: [string, { [key: string]: 0 }][];

    constructor(private systemStatusService: SystemStatusService) {}

    ngOnInit() {
        const systemErrorsObject: SystemError = this.getSystemErrors(this.systemStatusData);
        this.systemErrors = _.toPairs(systemErrorsObject);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.systemStatusData) {
            const systemErrorsObject: SystemError = this.getSystemErrors(this.systemStatusData);
            this.systemErrors = _.toPairs(systemErrorsObject);
        }
    }

    getAlarmCounts(systemObject) {
        if (!this.isReceivingData) return 0;
        return this.systemStatusService.getAlarmCounts(systemObject);
    }

    openSelectedPage(page) {
        this.onPageSelected.emit(page);
    }

    private getSystemErrors(obj) {
        let results = {};

        function traverse(obj, parentKey?) {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    let value = obj[key];
                    if (typeof value === 'object' && value !== null) {
                        let nestedParentKey = parentKey ? `${parentKey}.${key}` : key;
                        if (Array.isArray(value)) {
                            for (let i = 0; i < value.length; i++) {
                                traverse(value[i], `${nestedParentKey}.${i}`);
                            }
                        } else {
                            traverse(value, nestedParentKey);
                        }
                    } else {
                        if (value === 0) {
                            let objectKey = parentKey ? parentKey : key;
                            let objectValue = { [key]: value };
                            if (results[objectKey]) {
                                results[objectKey].push(objectValue);
                            } else {
                                if (key !== 'timeout') {
                                    results[objectKey] = [objectValue];
                                }
                            }
                        }
                        if (value === 1 && key === 'timeout') {
                            let objectKey = parentKey ? parentKey : key;
                            let objectValue = { [key]: value };
                            if (results[objectKey]) {
                                results[objectKey].push(objectValue);
                            } else {
                                results[objectKey] = [objectValue];
                            }
                        }
                    }
                }
            }
        }

        traverse(obj);

        return results;
    }
}
